import { AxiosResponse } from 'axios';
import axiosInstance from '../api';
import { inspections, InspectionType, Prisma } from '@prisma/client';

export interface CreateInspectionInput
  extends Omit<Prisma.inspectionsCreateInput, 'type'> {
  type: InspectionType[];
}

const inspectionsService = {
  find: async (params: Prisma.inspectionsFindManyArgs) => {
    const res: AxiosResponse<inspections[]> = await axiosInstance.get(
      '/inspections',
      { params }
    );
    return res.data;
  },
  create: async (data: CreateInspectionInput, manual?: boolean) => {
    const res: AxiosResponse<inspections> = await axiosInstance.post(
      '/inspections',
      data,
      { params: { manual } }
    );
    return res.data;
  },
};

export default inspectionsService;
